import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { SubScenarioForm } from "../Forms/SubScenarioForm.tsx";

export const SubScenarioDrawer = () => {
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.SubScenario} title={t("nodes.sub_scenario.drawers.title")}>
            <SubScenarioForm formId={FormId.SubScenarioForm} />
        </BaseConnectionCreatorDrawer>
    );
};
